import {useMutation, useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import {base} from '@/hooks/bateria/use-bateria'
import type {Page} from '@/hooks/empresa/organizacion/use-businesses'
import type {components} from '@/lib/api-schema'

export type ReporteHistorial = components['schemas']['BateriaReporteHistorialRead']

const REPORTE_HISTORIAL_PAGE_SIZE = 20

export function useReportesHistorial(
  businessId: string | undefined,
  evaluacionId: string | undefined,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['bateria-reportes-historial', businessId, evaluacionId],
    queryFn: async () =>
      (
        await api.get<Page<ReporteHistorial>>(`${base(businessId!)}/evaluaciones/${evaluacionId}/reportes`, {
          params: {page: 1, page_size: REPORTE_HISTORIAL_PAGE_SIZE},
        })
      ).data,
    enabled: enabled && !!businessId && !!evaluacionId,
  })
}

/** Solo del lado clínico (`require_system_user`): el empleador no puede verlo (Res. 2764/2022 art. 5 parágrafo).
 * Un 409 `sin_reservado` se repara regenerando el informe. */
export function useDownloadReporteReservado(businessId: string, evaluacionId: string) {
  return useMutation({
    mutationFn: async () =>
      (
        await api.get<components['schemas']['ReporteDownloadRead']>(
          `${base(businessId)}/evaluaciones/${evaluacionId}/reporte-reservado`
        )
      ).data,
    onSuccess: (data) => window.open(data.download_url, '_blank', 'noopener'),
  })
}
